var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.alertrecord')}}),_c('page-body',[_c('list',{attrs:{"listId":"AlertrecordList","resType":_vm.resType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }